import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { changeSidebarVisibility } from '../../redux/actions/basics_action/sidebarActions';

export default connect(state => ({ collapse: state.App.Sidebar.collapse }))(class TopbarSidebarButton extends PureComponent {
    changeSidebarVisibility = () => this.props.dispatch(changeSidebarVisibility());

    render() {
        return (
            <IconButton className="menu-btn" color="default" aria-label="Menu" onClick={this.changeSidebarVisibility} style={{ paddingLeft: '15px' }}>
                <MenuIcon />
            </IconButton>
        );
    }
});



// WEBPACK FOOTER //
// ./src/modules/App/components/topbar/TopbarSidebarButton.js